import React from 'react';
import { EyeIcon } from '@heroicons/react/20/solid';
import { deleteSentEmail } from '../../database/set-sent-email-data';

const viewRenderer = ({ data, setOpenEditModal, setSelectedId }) => {
  const handleClick = (event) => {
    const docId = event.currentTarget.getAttribute('data-doc-id');
    setSelectedId(docId);
    setOpenEditModal(true);
  };
  return (
    <div
      className="flex justify-center"
      data-doc-id={data.data.docId}
      onClick={handleClick}
    >
      <EyeIcon className="h-5 w-5 hover:text-blue-500 cursor-pointer" />
    </div>
  );
};

const onDeleteRenderer = ({ data }) => {
    return (
        <button
        type="button"
        onClick={() => deleteSentEmail(data.docId)}
        className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
        >
        Delete
        </button>
    );
};

const formatDateTime = (dateTime) => {
  const date = new Date(dateTime);
  return date.toLocaleString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).replace(',', '');
};

const sentEmailsColumns = (setOpenEditModal, setSelectedId) => [
  {
    name: 'view',
    header: '',
    minWidth: 50,
    render: (data) => viewRenderer({ data, setOpenEditModal, setSelectedId }),
    cellClassName: 'px-4 py-2',
    filterable: false,
  },
  {
    name: 'subject',
    header: 'Subject',
    minWidth: 200,
    cellClassName: 'px-4 py-2',
    filterable: true,
  },
  {
    name: 'to',
    header: 'To',
    minWidth: 200,
    cellClassName: 'px-4 py-2',
    filterable: true,
  },
  {
    name: 'from',
    header: 'From',
    minWidth: 200,
    cellClassName: 'px-4 py-2',
    filterable: true,
  },
  {
    name: 'dateTime',
    header: 'Date/Time(EST)',
    minWidth: 180,
    cellClassName: 'px-4 py-2',
    filterable: true,
    render: ({ value }) => formatDateTime(value),
    sortable: true,
  },
  {
    name: 'attachments',
    header: 'Attachments',
    minWidth: 100,
    cellClassName: 'px-4 py-2',
    filterable: true,
  },
  {
    name: 'emailType',
    header: 'Email Type',
    minWidth: 180,
    cellClassName: 'px-4 py-2',
    filterable: true,
  },
  {
    name: 'delete',
    header: 'Delete',
    minWidth: 50,
    render: ({ value, data }) => onDeleteRenderer({ data }),
    cellClassName: 'px-4 py-2',
    filterable: false,
  },
];

export default sentEmailsColumns; 